import React from 'react';
import Grid from '@material-ui/core/Grid';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';


const Referees = ({ officials }) => {
  return (
    <Grid container>
      <Grid item xs={12} sm>
        <List>
          {officials.referees.map(referee => (
            <ListItem key={referee}>
              <ListItemText primary={referee} secondary="Referee" />
            </ListItem>
          ))}
        </List>
      </Grid>
      <Grid item xs={12} sm>
        <List>
          {officials.linesman.map(linesman => (
            <ListItem key={linesman}>
              <ListItemText primary={linesman} secondary="Linesman" />
            </ListItem>
          ))}
        </List>
      </Grid>
    </Grid>
  );
}

export default Referees;